module.exports = __webpack_public_path__ + "static/media/KUDOS TITAN 505 SPEAKERS.fbd7ea48.png";